// Generate a react native component
import React from "react";
import { View, StyleSheet } from "react-native";
import { useRouter } from "expo-router";
import TposModeIcon from "./TposModeIcon";
import { FilterButtons } from "./FilterButtons";
import { FilterButton } from "./FilterButton";
import { ALL_FILTER, SETTINGS } from "@/app/constants/menuItem";
import { useDispatch, useSelector } from "react-redux";
import {
  getFilters,
  getEnablePickupInDriveThru,
  getSelectedFilter,
} from "@/app/selectors/config";
import { getCurrentLocale, useTranslateText } from "@/app/utils";
import { doChangeFilter } from "@/app/actions/config";
import { Filter } from "@/app/types/config";
import { Locale } from "@/app/types";
import { colors } from "@/app/constants/styles";

const getFilterName = ({ name }: Filter, locale?: Locale): string =>
  name[locale || getCurrentLocale()];

const Filters: React.FC = () => {
  const { t, locale } = useTranslateText();
  const dispatch = useDispatch();
  const router = useRouter();
  const selectedFilter = useSelector(getSelectedFilter);
  const filters = useSelector(getFilters);
  const enablePickupInDriveThru = useSelector(getEnablePickupInDriveThru);

  return (
    <View testID="filtersContainer" style={styles.container}>
      <FilterButtons
        filters={[
          {
            category: ALL_FILTER,
            name: {
              ar: t("homeScreen.all", { locale: "ar" }),
              en: t("homeScreen.all", { locale: "en" }),
            },
          },
          ...filters,
          {
            category: SETTINGS,
            name: {
              ar: t("tpos.settings", { locale: "ar" }),
              en: t("tpos.settings", { locale: "en" }),
            },
          },
        ]}
        getName={(prop) => getFilterName(prop, locale)}
        onPress={(category) => {
          if (category !== selectedFilter) {
            dispatch(doChangeFilter(category));
          }
        }}
        selectedCategory={selectedFilter}
      />
      {enablePickupInDriveThru && (
        <View style={styles.pickupDriveThruButton}>
          <FilterButton
            testID="pickupDriveThruButton"
            text={t("tpos.pickupDriveThru.button")}
            backgroundColor={colors.maroon}
            color={colors.white}
            onPress={() => router.push("/pickup-drive-thru")}
          />
        </View>
      )}
      <TposModeIcon />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  pickupDriveThruButton: {
    marginLeft: 10,
  },
});

export default Filters;
